import { render, staticRenderFns } from "./SoftwareWorkDetails.vue?vue&type=template&id=6cf20a14&scoped=true&"
import script from "./SoftwareWorkDetails.vue?vue&type=script&lang=js&"
export * from "./SoftwareWorkDetails.vue?vue&type=script&lang=js&"
import style0 from "./SoftwareWorkDetails.vue?vue&type=style&index=0&id=6cf20a14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf20a14",
  null
  
)

export default component.exports